import { render, staticRenderFns } from "./industry-info.vue?vue&type=template&id=08f096f1&"
import script from "./industry-info.vue?vue&type=script&lang=js&"
export * from "./industry-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports